
import { useAuth } from '@/context/AuthContext';
import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

export const useProAccess = () => {
  const { user } = useAuth();
  const [isProAccount, setIsProAccount] = useState(false);
  const [isDemoAccount, setIsDemoAccount] = useState(false);
  const [loading, setLoading] = useState(true);
  
  useEffect(() => {
    const checkSubscription = async () => {
      if (!user) {
        setIsProAccount(false);
        setIsDemoAccount(false);
        setLoading(false);
        return;
      }

      try {
        // Check if user is demo account from database
        const { data: profileData, error: profileError } = await supabase
          .from('profils_utilisateur')
          .select('is_demo')
          .eq('id', user.id)
          .maybeSingle();

        if (profileError) {
          console.error('Erreur lors de la vérification du profil:', profileError);
        }

        // Check admin role server-side via user_roles (no hardcoded emails)
        const { data: isAdminData } = await supabase.rpc('has_role', {
          _user_id: user.id,
          _role: 'admin',
        });

        const isDemo = profileData?.is_demo || isAdminData === true || false;
        setIsDemoAccount(isDemo);

        // Demo/admin accounts have unlimited access
        if (isDemo) {
          setIsProAccount(true);
          setLoading(false);
          return;
        }

        // Check subscription for non-demo accounts
        const { data, error } = await supabase
          .from('abonnements')
          .select('*')
          .eq('user_id', user.id)
          .eq('statut', 'actif')
          .gte('date_fin', new Date().toISOString())
          .order('created_at', { ascending: false })
          .limit(1)
          .maybeSingle();

        if (error) {
          console.error('Erreur lors de la vérification de l\'abonnement:', error);
          setIsProAccount(false);
        } else {
          // User has pro account if they have an active non-free subscription
          setIsProAccount(data && data.plan !== 'gratuit');
        }
      } catch (error) {
        console.error('Erreur lors de la vérification de l\'abonnement:', error);
        setIsProAccount(false);
        setIsDemoAccount(false);
      } finally {
        setLoading(false);
      }
    };

    checkSubscription();
  }, [user]);
  
  return {
    isProAccount,
    isDemoAccount,
    loading
  };
};
